// extracted by mini-css-extract-plugin
export var articles = "style-module--articles--c0ffb";
export var buttonContainer = "style-module--buttonContainer--2ca09";
export var carousel = "style-module--carousel--80e94";
export var categories = "style-module--categories--582e1";
export var container = "style-module--container--7f237";
export var date = "style-module--date--96824";
export var description = "style-module--description--5463b";
export var id = "style-module--id--3364b";
export var idContainer = "style-module--idContainer--ab335";
export var imageContainer = "style-module--imageContainer--a83c6";
export var infoSection = "style-module--infoSection--8b8b9";
export var label = "style-module--label--1e919";
export var latestSection = "style-module--latestSection--a44b3";
export var leftWrapper = "style-module--leftWrapper--8dfcf";
export var list = "style-module--list--0d4ee";
export var mainArtisan = "style-module--mainArtisan--0cb61";
export var mainFeature = "style-module--mainFeature--d1e01";
export var mainRequest = "style-module--mainRequest--69250";
export var mainSeries = "style-module--mainSeries--d19e2";
export var mainVideo = "style-module--mainVideo--56d21";
export var marker = "style-module--marker--96139";
export var message = "style-module--message--b2693";
export var more = "style-module--more--971f5";
export var pickupSection = "style-module--pickupSection--45d3e";
export var play = "style-module--play--31a97";
export var rankingContainer = "style-module--rankingContainer--de67f";
export var rankingSection = "style-module--rankingSection--509b6";
export var search = "style-module--search--bdf28";
export var searchAndTag = "style-module--searchAndTag--24848";
export var sideSection = "style-module--sideSection--ab531";
export var tabContent = "style-module--tabContent--093af";
export var tabContentItem = "style-module--tabContentItem--117f4";
export var tabSection = "style-module--tabSection--6e4dc";
export var tabs = "style-module--tabs--2344a";
export var tag = "style-module--tag--2c6d7";
export var tags = "style-module--tags--615f7";
export var title = "style-module--title--6ce8f";
export var top = "style-module--top--f63c7";
export var topWrapper = "style-module--topWrapper--838e8";
export var ui = "style-module--ui--150e5";
export var videoSection = "style-module--videoSection--888e5";
export var videos = "style-module--videos--4ee4a";